/// <reference path="common.module.ts" />
module Meevo.Components.Common {

    export interface IDataConverterService {
        toCsv(data: string[][]): string;
    }

    class DataConverterService implements IDataConverterService {

        static factory(): Function {
            const service = () => {
                return new DataConverterService();
            };

            return service;
        }

        toCsv(data: string[][]): string {
            let csvString = '';

            for (const row of data) {
                csvString += `${row.join(',')}\n`;
            }

            return csvString;
        }
    }

    angular.module('meevo.components.common')
        .factory('meevo.components.common.DataConverterService', DataConverterService.factory());
}
